import logo from 'src/assets/images/antiscam/popup_logo1.png';
import styled from 'styled-components';

const ImageWrap = styled.img`
  width: auto;
  height: auto;
  margin: 0 auto;
`;

const PCContent = () => {
  return (
    <div>
      스마트피싱보호 앱 다운로드를 위한 '메시지'를 발송하였습니다.
      <br />
      <br />
      <b>
        '스마트피싱보호'앱을 설치하셔야만 다양한 보이스피싱 피해로부터
        <br />
        안전하게 보호받으실 수 있습니다.
      </b>
      <br />
      <br />
      <span>
        만일 메시지를 수신하지 못하셨다면, Google play 스토어에서
        <br />
        '스마트피싱보호'를 검색한 후 설치해주세요!
      </span>
      <br />
      <br />
      <ImageWrap src={logo} alt="" />
    </div>
  );
};

export default PCContent;
